var _defaultTheme$token, _defaultTheme$token2;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { App, message as antMessage, Modal as AntModal, notification as antNotification } from 'antd';
import formatToken from 'antd/lib/theme/util/alias';
import theme from "../theme";
import defaultTheme from "../theme/default";
var defaultAlgorithm = theme.defaultAlgorithm,
  defaultSeed = theme.defaultSeed,
  useToken = theme.useToken;

// 设置默认 token
var mapToken = _objectSpread(_objectSpread(_objectSpread({}, defaultAlgorithm(defaultSeed)), defaultTheme.token), {}, {
  // 需要覆盖部分 Alias Token 的值
  override: {
    boxShadow: (_defaultTheme$token = defaultTheme.token) === null || _defaultTheme$token === void 0 ? void 0 : _defaultTheme$token.boxShadow,
    boxShadowSecondary: (_defaultTheme$token2 = defaultTheme.token) === null || _defaultTheme$token2 === void 0 ? void 0 : _defaultTheme$token2.boxShadowSecondary
  }
});
var token = formatToken(mapToken);
var message = antMessage;
var notification = antNotification;
var modal = AntModal;
export default (function () {
  // 自动注入 useToken，避免每次使用都要声明一遍，比较繁琐
  token = useToken().token;
  var staticFunction = App.useApp();
  // 替换 antd 的静态方法，支持消费 ConfigProvider 配置
  message = _objectSpread(_objectSpread({}, staticFunction.message), {}, {
    useMessage: antMessage.useMessage
  });
  notification = _objectSpread(_objectSpread({}, staticFunction.notification), {}, {
    useNotification: antNotification.useNotification
  });
  modal = _objectSpread(_objectSpread({}, staticFunction.modal), {}, {
    useModal: AntModal.useModal
  });
  return null;
});
export { token, message, notification, modal };